// default value should go to the combined form values in defaultFormValues.js
export const initialFormValues = {
  overview: {
    promoCode: '',
    consentGiven: false,
    applicationReason: '',
    conditionalStop: '',
  },
  contactDetails: {
    mobileNumber: '',
    emailAddress: '',
    confirmEmail: '',
  },
  verification: {
    verificationCode: '',
  },
  emailVerification: {
    verificationCode: '',
  },
  password: {
    password: '', // verbal password. Required when a user doesn't have a valid biometrics verification.
  },
  biometricsAddressDetails: {
    residentialStatus: '',
    updateCurrentAddress: '',
    changeAddress: false,
    currentAddress: {
      useManualAddress: false,
      address: {
        unitNumber: '',
        streetNumber: '',
        streetName: '',
        streetType: '',
        suburb: '',
        city: '',
        postcode: '',
        poBoxNumber: '',
        addressType: '',
        countryCode: '',
      },
    },
    previousAddress: {
      useManualAddress: false,
      address: {
        unitNumber: '',
        streetNumber: '',
        streetName: '',
        streetType: '',
        suburb: '',
        city: '',
        postcode: '',
        poBoxNumber: '',
        addressType: '',
        countryCode: '',
      },
    },
    postalAddress: {
      useManualAddress: false,
      address: {
        unitNumber: '',
        streetNumber: '',
        streetName: '',
        streetType: '',
        suburb: '',
        city: '',
        postcode: '',
        poBoxNumber: '',
        addressType: '',
        countryCode: '',
      },
    },
    hasNonDomesticPreviousAddress: false,
    isPostalSameWithResidential: '',
    lengthOfCurrentResidency: {
      years: '',
      months: '',
    },
  },
  personalDetails: {
    title: '',
    firstName: '',
    middleName: '',
    lastName: '',
    dateOfBirth: {
      day: '',
      month: '',
      year: '',
    },
    hasMiddleName: 'no',
    hasNzDriverLicence: '',
    relationshipStatus: '',
    numberOfDependents: '',
    idType: '',
    licenceNumber: '',
    version: '',
    idNumber: '',
    expiryDate: {
      day: '',
      month: '',
      year: '',
    },
    nzResidencyNumber: '',
    issuingCountry: '',
    dvsConsent: false,
  },
  otherDetails: {
    residentialStatus: '',
    lengthOfCurrentResidency: {
      years: '',
      months: '',
    },
    isPostalSameWithResidential: '',
    hasNonDomesticPreviousAddress: false,
    currentAddress: {
      useManualAddress: false,
      address: {
        unitNumber: '',
        streetNumber: '',
        streetName: '',
        streetType: '',
        suburb: '',
        city: '',
        postcode: '',
        poBoxNumber: '',
        addressType: '',
        countryCode: '',
      },
    },
    previousAddress: {
      useManualAddress: false,
      address: {
        unitNumber: '',
        streetNumber: '',
        streetName: '',
        streetType: '',
        suburb: '',
        city: '',
        postcode: '',
        poBoxNumber: '',
        addressType: '',
        countryCode: '',
      },
    },
    postalAddress: {
      useManualAddress: false,
      address: {
        unitNumber: '',
        streetNumber: '',
        streetName: '',
        streetType: '',
        suburb: '',
        city: '',
        postcode: '',
        poBoxNumber: '',
        addressType: '',
        countryCode: '',
      },
    },
  },
  extraDetails: {
    idType: '',
    licenceNumber: '',
    version: '',
    idNumber: '',
    expiryDate: {
      day: '',
      month: '',
      year: '',
    },
    name: '',
    dvsConsent: false,
    medicareCardNumber: '',
    individualReferenceNumber: '',
    medicareCardColour: '',
    expiryDateGreen: {
      day: '',
      month: '',
      year: '',
    },
    expiryDateNonGreen: {
      day: '',
      month: '',
      year: '',
    },
    nameOnPassport: '',
    issuingCountry: '',
    visaStartDate: {
      day: '',
      month: '',
      year: '',
    },
    visaEndDate: {
      day: '',
      month: '',
      year: '',
    },
  },
  expensesDetails: {
    isExpensesShared: '',
    isSummaryExpenses: '',
    isRevolvingOrOffsetMortgage: '',
    facilityLimit: '',
    // Your residential expenses
    primaryPropertyMortgageRentBoard: {
      amount: '',
      frequency: '',
    },
    propertyUtilitiesOther: {
      amount: '',
      frequency: '',
    },
    // Your living expenses
    foodGroceriesLifestyleEntertainment: {
      amount: '',
      frequency: '',
    },
    generalInsurance: {
      amount: '',
      frequency: '',
    },
    transport: {
      amount: '',
      frequency: '',
    },
    educationChildcare: {
      amount: '',
      frequency: '',
    },
    personalFitnessMedical: {
      amount: '',
      frequency: '',
    },
    other: {
      amount: '',
      frequency: '',
    },
    basicExpenses: {
      amount: '',
      frequency: '',
    },
    additionalExpenses: {
      amount: '',
      frequency: '',
    },
  },
  employmentDetails: {
    occupation: '',
    industry: '',
    incomeSource: '',
    employerName: '',
    lengthOfTimeAtCurrentEmployer: {
      years: '',
      months: '',
    },
    lengthOfUnemployment: {
      years: '',
      months: '',
    },
    income: {
      amount: '',
      frequency: '',
    },
    employmentStatus: '',
    hasOtherIncome: '',
    otherEmploymentStatus: '',
    otherIncome: {
      amount: '',
      frequency: '',
    },
    incomeAdjustmentRequired: '',
    conditionalStop: '',
  },
  additionalDebtsDetails: {
    hasOtherDebts: '',
    totalCardLimits: '',
    amountOwingOnCreditCard: '',
    secondaryPropertyMortgageRentBoard: {
      amount: '',
      frequency: 'monthly',
    },
    loanRepayment: {
      amount: '',
      frequency: 'monthly',
    },
  },
  achDetails: {
    hasAch: null,
    sameCurrentAddress: 'yes',
    personalDetails: {
      hasMiddleName: 'no',
      title: '',
      firstName: '',
      lastName: '',
      middleName: '',
      dateOfBirth: {
        day: '',
        month: '',
        year: '',
      },
      mobileNumber: '',
      emailAddress: '',
    },
    currentAddress: {
      useManualAddress: false,
      address: {
        unitNumber: '',
        streetNumber: '',
        streetName: '',
        streetType: '',
        suburb: '',
        city: '',
        postcode: '',
        poBoxNumber: '',
        addressType: '',
        countryCode: '',
      },
    },
  },
  creditLimitAcceptance: {
    creditLimit: '',
    accepted: false,
  },
  confirmCreditLimit: {
    newCreditLimit: '',
  },
  acceptance: {
    accepted: false,
  },
  creditLimitRequest: {
    creditLimitOptions: null,
    newCreditLimit: '',
  },
  balanceTransfer: {
    requestBalanceTransfer: null,
    balanceTransferList: {
      bt0: {
        amount: '',
        institutionName: '',
        billerCode: '',
        billerRef: '',
      },
    },
    tncConsent: false,
    confirmationConsent: false,
  },
};
